module.exports = __webpack_public_path__ + "static/media/beverages.39c63165.svg";